
  import React from "react"
  import Component from "/Users/ayozemr/Documents/repositories/ayozemr/dismocan.com/src/layouts/index.js"
  import data from "/Users/ayozemr/Documents/repositories/ayozemr/dismocan.com/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js